package com.milta.core.localization.translations.de

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonnement abgelaufen",
    driverSoloMessage = "Ihr Abonnement ist abgelaufen. Verlängern Sie es, um fortzufahren.",
    patronMessage = "Ihr Abonnement ist abgelaufen. Ihr Team hat keinen Zugriff mehr auf Milta.",
    driverUnderPatronMessage = "Das Abonnement Ihrer Organisation ist abgelaufen. Wenden Sie sich an Ihre Organisation, um Ihren Zugriff wiederherzustellen.",
    renewButton = "Verlängern",
    close = "Schließen",
    subscribeButtonTemplate = "Für %s abonnieren",
    driverLinkCodeHint = "Arbeiten Sie für ein Unternehmen? Geben Sie ihm diesen Code: Nach der Verknüpfung sind Sie durch sein Abonnement abgedeckt.",
    checkAccessButton = "Meinen Zugang prüfen",
    accessStillUnavailable = "Zugang weiterhin nicht verfügbar",
)
